import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDesigner = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20.295,
	height: 20.285,
	viewBox: "0 0 20.295 20.285",
	fill: "#323338",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_6066",
		"data-name": "Group 6066",
		transform: "translate(-1.997 -1.708)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_6065",
			"data-name": "Group 6065",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8554",
					"data-name": "Path 8554",
					d: "M20.45,6l.49-1.06L22,4.45a.5.5,0,0,0,0-.91l-1.06-.49L20.45,2a.5.5,0,0,0-.91,0l-.49,1.06L18,3.55a.5.5,0,0,0,0,.91l1.06.49L19.55,6A.492.492,0,0,0,20.45,6Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8555",
					"data-name": "Path 8555",
					d: "M8.95,6l.49-1.06,1.06-.49a.5.5,0,0,0,0-.91L9.44,3.06,8.95,2a.492.492,0,0,0-.9,0L7.56,3.06,6.5,3.55a.5.5,0,0,0,0,.91l1.06.49L8.05,6A.492.492,0,0,0,8.95,6Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8556",
					"data-name": "Path 8556",
					d: "M19.55,13.5l-.49,1.06L18,15.05a.5.5,0,0,0,0,.91l1.06.49.49,1.06a.5.5,0,0,0,.91,0l.49-1.06,1.05-.5a.5.5,0,0,0,0-.91l-1.06-.49-.49-1.06A.5.5,0,0,0,19.55,13.5Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_8557",
					"data-name": "Path 8557",
					d: "M17.71,9.12,14.88,6.29a1,1,0,0,0-1.41,0L2.29,17.46a1,1,0,0,0,0,1.41L5.12,21.7a1,1,0,0,0,1.41,0L17.7,10.53A.987.987,0,0,0,17.71,9.12Zm-3.5,2.09L12.8,9.8l1.38-1.38,1.41,1.41Z"
				})
			]
		})
	})
});
export { SvgDesigner as ReactComponent };
